import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/app-design.css';
import './styles/finance-design.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { serviceWorkerRegistrieren } from './utils/pushNotifications';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service Worker fuer Browser-Benachrichtigungen. Die Registrierung allein
// fragt NICHTS ab und zeigt nichts an - die Erlaubnis holt erst die Profilseite
// ein, wenn der Nutzer sie dort einschaltet. Hier steht sie, damit ein bereits
// erteiltes Abo nach einem Neuladen sofort wieder bedient wird.
serviceWorkerRegistrieren();
